export const DEFAULT_COMPOSER_RESERVED_SPACE_PX = 140;
export const COMPOSER_BOTTOM_OFFSET_PX = 20;
export const COMPOSER_OVERLAP_BUFFER_PX = 8;

/**
 * Extra bottom padding for chat history so the last answer (and Copy/Export)
 * can scroll above follow-ups. The history pane already reserves
 * DEFAULT_COMPOSER_RESERVED_SPACE_PX for the input; this returns only the
 * additional overlap when the composer grows (e.g. follow-up chips).
 */
export function getComposerOverlapPaddingPx({
  composerHeight = 0,
  hasMessages = false,
  isEmptyStateCentered = false,
} = {}) {
  if (!hasMessages || isEmptyStateCentered) {
    return 0;
  }

  const heightPx = Math.ceil(Number(composerHeight) || 0);
  const totalComposerSpace = heightPx + COMPOSER_BOTTOM_OFFSET_PX;
  const overlap =
    totalComposerSpace -
    DEFAULT_COMPOSER_RESERVED_SPACE_PX +
    COMPOSER_OVERLAP_BUFFER_PX;

  return Math.max(0, overlap);
}
